import React, { memo } from 'react';

import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { TOOLTIP_ENTER_DELAY, TOOLTIP_OFFSET_Y } from './TooltipWrapper.constants';

export const getPopperProps = (anchorEl, extraModifiers = []) => ({
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, TOOLTIP_OFFSET_Y],
      },
    },
    ...extraModifiers,
  ],
  ...(anchorEl && { anchorEl }),
  sx: { zIndex: '2000 !important' },
});

const defaultStyles = {
  fontSize: '12px',
  fontWeight: 400,
};

const TooltipWrapper = ({
  children,
  title,
  tooltipSx = defaultStyles,
  open,
  anchorEl,
  popperModifiers = [],
  disableInteractive = false,
  enterDelay = TOOLTIP_ENTER_DELAY,
}) => (
  <Tooltip
    PopperProps={getPopperProps(anchorEl, popperModifiers)}
    disableInteractive={disableInteractive}
    enterDelay={enterDelay}
    placement="bottom-start"
    {...(tooltipSx && {
      slotProps: {
        tooltip: {
          sx: tooltipSx,
        },
      },
    })}
    {...(anchorEl && {
      open,
    })}
    title={title}
  >
    {children}
  </Tooltip>
);

TooltipWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  tooltipSx: PropTypes.object,
  open: PropTypes.bool,
  followMouse: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([PropTypes.instanceOf(HTMLElement), PropTypes.node]),
  popperModifiers: PropTypes.array,
  disableInteractive: PropTypes.bool,
  enterDelay: PropTypes.number,
};

export default memo(TooltipWrapper);
